<div class="inner-page-header py-5 text-white">
  <div class="container px-lg-5">
    <h1 class="display-5 fw-bold text-uppercase mb-2">Latest in College</h1>
    <p class="lead mb-0 text-orange-light">Stay connected with our campus events, milestones, and announcements</p>
  </div>
</div>

<div class="container px-lg-5 py-5">
  <div class="row g-4">
    <!-- Left Sidebar: Year Selection Tabs -->
    <div class="col-12 col-md-4 col-lg-3">
      <div class="year-sidebar p-3 rounded-4 shadow-sm bg-white border-top border-4 border-orange">
        <div class="sidebar-header mb-3 pb-2 border-bottom text-muted d-flex align-items-center">
          <i class="fa-solid fa-calendar-days text-orange me-2"></i>
          <span class="fw-bold uppercase-title">Academic Years</span>
        </div>
        
        <div class="d-flex flex-column gap-2">
          <button 
            *ngFor="let item of academicYears" 
            (click)="selectYear(item)"
            [class.active]="selectedYear.year === item.year"
            class="year-tab-btn d-flex align-items-center justify-content-between p-3 rounded-3 border-0 text-start transition-all"
          >
            <div class="d-flex align-items-center gap-3">
              <div class="year-icon-box rounded-2 d-flex align-items-center justify-content-center text-white">
                <i class="fa-regular fa-folder-open"></i>
              </div>
              <span class="fw-bold year-text">{{ item.year }}</span>
            </div>
            <i class="fa-solid fa-chevron-right arrow-indicator"></i>
          </button>
        </div>
      </div>

      <!-- Quick Contact / Info Strip -->
      <div class="info-strip mt-4 p-4 rounded-4 text-white text-center shadow-lg" style="background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%);">
        <i class="fa-solid fa-circle-nodes display-6 text-orange-light mb-3"></i>
        <h5 class="fw-bold mb-2">Academic Hub</h5>
        <p class="small text-white-50 mb-0">Browse through official annual records and major institution updates.</p>
      </div>
    </div>

    <!-- Right Side Content: Event Cards -->
    <div class="col-12 col-md-8 col-lg-9">
      <div class="content-header mb-4 d-flex align-items-center justify-content-between">
        <h3 class="fw-bold text-success m-0">
          <i class="fa-solid fa-bullhorn text-orange me-2"></i> Events & Updates ({{ selectedYear.year }})
        </h3>
        <span class="badge bg-orange px-3 py-2 rounded-pill fs-6">{{ selectedYear.events.length }} Events Found</span>
      </div>

      <div class="d-flex flex-column gap-3">
        <!-- Horizontal Premium Event Pill/Card -->
        <div 
          *ngFor="let event of selectedYear.events; let idx = index" 
          class="event-pill-card bg-white p-3 p-md-4 rounded-4 shadow-sm border border-light transition-all d-flex flex-column flex-md-row align-items-md-center gap-3 gap-md-4"
        >
          <!-- Left Icon Circle -->
          <div class="event-icon-circle rounded-circle d-flex align-items-center justify-content-center text-white shadow-sm flex-shrink-0">
            <i class="fa-solid" [ngClass]="event.icon"></i>
          </div>

          <!-- Middle Event Info -->
          <div class="flex-grow-1">
            <div class="d-flex flex-wrap align-items-center gap-2 mb-1">
              <h4 class="fw-bold text-dark m-0 fs-5 event-title">{{ event.title }}</h4>
              <span class="badge bg-light text-muted border py-1 px-2 rounded-pill small">
                <i class="fa-regular fa-clock me-1 text-orange"></i> {{ event.date }}
              </span>
            </div>
            <p class="text-muted m-0 text-justify event-desc">{{ event.description }}</p>
          </div>

          <!-- Right Arrow Button -->
          <div class="flex-shrink-0 text-end d-none d-md-block">
            <div class="arrow-btn rounded-circle d-flex align-items-center justify-content-center border transition-all text-orange">
              <span class="fw-bold">➤</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

